import React, { useContext } from 'react'
import dynamic from 'next/dynamic'
import { Box } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import useSeti from '@/hooks/useSeti'

const HomeDesktop = dynamic(() => import('./HomeDesktop'))
const HomeMobile = dynamic(() => import('./HomeMobile'))

export default function Home() {
  useSeti('AA_HOMEPAGE') // AA Test: Unconditional firing and no visual changes
  const { isMobile = false } = useContext(BootstrapDataContext)

  return <Box>{isMobile ? <HomeMobile /> : <HomeDesktop />}</Box>
}
